import Form, { ButtonItem, Item, Label, SimpleItem, FormRef } from 'devextreme-react/form';
import { useEffect, useRef, useState } from 'react';
import { OrdiniApi } from '../../data';
import { apiConfiguration } from '../../apiConfig';
import { ClickEvent } from 'devextreme/ui/button';
import { showError } from '../../utils/errorHandling';
import LoadPanel from 'devextreme-react/load-panel';
import React from 'react';
import { dipendenzeDataSource } from '../../datasources/dipendenzeDataSource';
import { customersDataSource } from '../../datasources/customersDataSource';
import { FieldDataChangedEvent } from 'devextreme/ui/form';
import {OrdineCreateDTOFromJSON, OrdineUpdateDTOFromJSON} from "../../data/models";
import { useTranslation } from 'react-i18next';

type Props = {
    idOrdine?: number,
    idCliente: number,
    tipoOrdine: string,
    onUpdated: () => void,
    onInserted: (idOrdine: number) => void,
    readonly?: boolean,
    isInsert: boolean,
    isUpdate: boolean
}

type state = {
    datasource: any
}

type stateform = {
    isInsert: boolean;
    isUpdate: boolean;
}

const OrderForm = (props: Props) => {
    const [state, setState] = useState<state>({datasource: null});
    const [stateform, setStateform] = useState<stateform>({isInsert: props.isInsert, isUpdate: props.isUpdate});   
    
    const customerEditorOptions = { dataSource: customersDataSource(""), valueExpr: "id", displayExpr: "ragioneSociale", searchEnabled: true };
    const dipendenzeEditorOptions = { dataSource: state.datasource, valueExpr: "id", displayExpr: "nome", searchEnabled: true };
   
    const [formData, setFormData] = useState<any>();
    const formRef = useRef<FormRef>(null);
    const [loadPanelVisible, setLoadPanelVisible] = useState<boolean>(false);    
    const { t } = useTranslation();

    useEffect(() => {
        setFormData(null);
        const api = new OrdiniApi(apiConfiguration);
        if (props.idOrdine) {
            api.getOrdineById({ idOrdine: props.idOrdine })
                .then(function (data) {
                    setFormData(data);
                })
                .catch(showError)
                .finally(() => {
                    setState({ datasource: dipendenzeDataSource(props.idCliente.toString())});
                });
        }    

    }, []);

    function save_click(e: ClickEvent) {
        var validate = formRef.current?.instance().validate();

        if (validate?.isValid) {
            const api = new OrdiniApi(apiConfiguration);
            var data = formRef.current?.instance().option("formData");

            if (!data.idOrdine) {
                setLoadPanelVisible(true);                

                var newordineCreateDTO = OrdineCreateDTOFromJSON(JSON.stringify(data));
                newordineCreateDTO.idDipendenza = data.idDeposito;     

                api.insertOrdine({
                    ordineCreateDTO: newordineCreateDTO
                })
                    .catch(showError)
                    .then(function (dataresp) {
                        if (dataresp) {
                            setFormData(dataresp);
                            if (dataresp?.idOrdine)
                                props.onInserted(dataresp?.idOrdine);
                        }
                    })
                    .finally(() => {
                        setLoadPanelVisible(false);
                        setStateform({ isInsert: false, isUpdate: true});
                    });
            }
            else {
                
                var newordineUpdateDTO = OrdineUpdateDTOFromJSON(JSON.stringify(data));
                newordineUpdateDTO.idDipendenza = data.idDeposito;
                newordineUpdateDTO.dataConsegna = data.dataConsegna;
                newordineUpdateDTO.note = data.note;
                
                setLoadPanelVisible(true);
                api.updateOrdine({
                    idOrdine: data.idOrdine,
                    ordineUpdateDTO: newordineUpdateDTO
                })
                    .catch(showError)
                    .then((props.onUpdated))
                    .finally(() => setLoadPanelVisible(false));
            }
        }
    }

    function onFieldDataChanged(e: FieldDataChangedEvent) {
         if (e.dataField==="idCliente"){
            setState({ datasource: dipendenzeDataSource(e.value)});
            e.component.updateData("idDeposito", "");
        }   
    }

    return (
        <React.Fragment>
            <Form id="form" ref={formRef} colCount={3} formData={formData} onFieldDataChanged={onFieldDataChanged} labelMode='floating'>
                <Item dataField="dataConsegna" editorType='dxDateBox' isRequired={true} visible={stateform.isUpdate} disabled={props.readonly} >
                    <Label text={t ('dataConsegna')} />
                </Item>
                <Item dataField="numero" disabled={true} visible={stateform.isUpdate}>
                    <Label text={t ('numero')} />
                </Item>
                <Item dataField="idCliente" colSpan={1} editorType="dxSelectBox" editorOptions={customerEditorOptions} isRequired={true} visible={stateform.isInsert}>
                    <Label text={t ('cliente')} />
                </Item>
                <Item dataField="idDeposito" colSpan={1} editorType="dxSelectBox" editorOptions={dipendenzeEditorOptions} isRequired={true} visible={stateform.isInsert ||stateform.isUpdate} disabled={props.readonly}>
                    <Label text={t ('deposito')} />
                </Item>
                <Item dataField="note" colSpan={2} visible={stateform.isUpdate} disabled={props.readonly}>
                    <Label text={t ('note')} />
                </Item>

                <ButtonItem horizontalAlignment="right" colSpan={1}
                    buttonOptions={{
                        text: t('salva'),
                        type: 'success',
                        width: '300px',
                        onClick: save_click,
                        disabled: props.readonly
                    }}
                />

            </Form>
            <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                position={{ of: '#form' }}
                visible={loadPanelVisible}
                showIndicator={true}
                shading={true}
                showPane={true}
                hideOnOutsideClick={false}
            />
        </React.Fragment>
    );
};

export default OrderForm;
